<div class="info-card">
  <div class="info-icon">!</div>
  <p class="info-text">{{ message }}</p>
</div>
